export { ClaimTemplateApi } from './ClaimTemplateApi';
